import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';
import DashboardLayout from './components/layout/DashboardLayout';
import Dashboard from './pages/Dashboard';
import Clientes from './pages/Clientes';
import ClientesPotenciales from './pages/ClientesPotenciales';
import Citas from './pages/Citas';
import CitasITV from './pages/CitasITV';
import Presupuestos from './pages/Presupuestos';
import Almacen from './pages/Almacen';
import Reservas from './pages/Reservas';
import Equipo from './pages/Equipo';
import Tareas from './pages/Tareas';
import Incidencias from './pages/Incidencias';
import Fichajes from './pages/Fichajes';
import Vacaciones from './pages/Vacaciones';
import Restaurante from './pages/Restaurante';
import CartaPublica from './pages/CartaPublica';
import AdelantadorITV from './pages/AdelantadorITV';
import Proyectos from './pages/Proyectos';
import MonitorActividad from './pages/MonitorActividad';
import MonitorTrafico from './pages/MonitorTrafico';
import Comunicados from './pages/Comunicados';
import Calendario from './pages/Calendario';
import Archivos from './pages/Archivos';
import Configuracion from './pages/Configuracion';
import AjustesEmpresa from './pages/AjustesEmpresa';
import LandingEmpresaPublica from './pages/LandingEmpresaPublica';
import LandingTrixPublica from './pages/LandingTrixPublica';
import FirmarDocumentoPublico from './pages/FirmarDocumentoPublico';
import DemoVenta from './pages/DemoVenta';
import PropuestaComercial from './pages/PropuestaComercial';
import FeatureGate from './components/FeatureGate';
import DocumentosFirma from './pages/DocumentosFirma';
import { subscribeAILoading } from './utils/api';
import './styles/App.css';
import './styles/components.css';

export default function App() {
  const [iaLoading, setIaLoading] = useState(false);

  useEffect(() => {
    const unsubscribe = subscribeAILoading(setIaLoading);
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (iaLoading) {
      document.body.classList.add('ia-busy');
    } else {
      document.body.classList.remove('ia-busy');
    }
    return () => document.body.classList.remove('ia-busy');
  }, [iaLoading]);

  return (
    <>
      <Routes>
        <Route path="/" element={<LandingTrixPublica />} />
        <Route path="/login" element={<Login />} />

        {/* Comanda pública por QR de mesa (sin autenticación) */}
        <Route path="/carta/:qrToken" element={<CartaPublica />} />
        <Route path="/firmar/:token" element={<FirmarDocumentoPublico />} />
        <Route path="/demo-venta" element={<DemoVenta />} />
        <Route path="/propuesta-comercial" element={<PropuestaComercial />} />
        <Route path="/empresa/:slug" element={<LandingEmpresaPublica />} />
        <Route path="/landing-trix" element={<LandingTrixPublica />} />

        <Route
          path="/app/*"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <Routes>
                  <Route index element={<Dashboard />} />
                  <Route path="clientes" element={<Clientes />} />
                  <Route path="clientes-potenciales" element={<ClientesPotenciales />} />
                  <Route path="comunicados" element={<Comunicados />} />
                  <Route path="citas" element={<Citas />} />
                  <Route path="calendario" element={<Calendario />} />
                  <Route path="archivos" element={<Archivos />} />
                  <Route path="citas-itv" element={<FeatureGate flag="itv_adelantador" fallback={<div className="page"><h1 className="page-title">Citas ITV</h1><div className="alert-warning">La funcionalidad de ITV no está habilitada para esta empresa.</div></div>}><CitasITV /></FeatureGate>} />
                  <Route path="adelantador-itv" element={<FeatureGate flag="itv_adelantador" fallback={<div className="page"><h1 className="page-title">Adelantador ITV</h1><div className="alert-warning">Este módulo no está disponible porque la función de adelantador ITV está desactivada.</div></div>}><AdelantadorITV /></FeatureGate>} />
                  <Route path="presupuestos" element={<FeatureGate flag="facturacion_verifactu" fallback={<div className="page"><h1 className="page-title">Presupuestos y facturas</h1><div className="alert-warning">La facturación electrónica no está habilitada para esta empresa.</div></div>}><Presupuestos /></FeatureGate>} />
                  <Route path="almacen" element={<Almacen />} />
                  <Route path="reservas" element={<Reservas />} />
                  <Route path="equipo" element={<Equipo />} />
                  <Route path="tareas" element={<Tareas />} />
                  <Route path="incidencias" element={<Incidencias />} />
                  <Route path="fichajes" element={<Fichajes />} />
                  <Route path="monitor-actividad" element={<MonitorActividad />} />
                  <Route path="documentos-firma" element={<FeatureGate flag="firma_digital" fallback={<div className="page"><h1 className="page-title">Documentos de firma</h1><div className="alert-warning">La firma digital no está habilitada para esta empresa.</div></div>}><DocumentosFirma /></FeatureGate>} />
                  <Route path="trafico" element={<MonitorTrafico />} />
                  <Route path="vacaciones" element={<Vacaciones />} />
                  <Route path="restaurante" element={<FeatureGate flag="qr_mesa" fallback={<div className="page"><h1 className="page-title">Restaurante</h1><div className="alert-warning">El QR de mesa no está habilitado para esta empresa.</div></div>}><Restaurante /></FeatureGate>} />
                  <Route path="proyectos" element={<FeatureGate flag="coste_real_obra" fallback={<div className="page"><h1 className="page-title">Proyectos</h1><div className="alert-warning">La funcionalidad de coste real por obra no está habilitada para esta empresa.</div></div>}><Proyectos /></FeatureGate>} />
                  <Route path="ajustes-empresa" element={<AjustesEmpresa />} />
                  <Route path="empresas" element={<Configuracion />} />
                  <Route path="configuracion" element={<Configuracion />} />
                  <Route path="*" element={<Navigate to="/app" replace />} />
                </Routes>
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<Navigate to="/app" replace />} />
      </Routes>

      {iaLoading ? (
        <div className="ia-global-overlay" role="status" aria-live="polite" aria-label="Procesando tarea de inteligencia artificial">
          <div className="ia-global-overlay-card">
            <div className="trix-spinner" />
            <p>Procesando con IA...</p>
          </div>
        </div>
      ) : null}
    </>
  );
}
